
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire494a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire494a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = new Map();
function $ef7689007096c8a0$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ef7689007096c8a0$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $6f580ff1c7c16ea2$exports = {};

(parcelRequire("kyEFX")).register(new URL("", import.meta.url).toString(), JSON.parse('["2Qpba","index.2d61e064.js","2bCBW","black-1.b9e2a0c5.jpg","is93H","black-2.a498d6b2.jpg","g57Dl","black-3.59840d4e.jpg","lEypp","black-4.a3891a45.jpg","3XMyJ","black-5.638afd2c.jpg","kdhR8","blue-1.515b7ea5.jpg","9hLwj","blue-2.72f5326f.jpg","7c2T2","blue-3.8869fda4.jpg","db4k8","blue-4.5e1a0e59.jpg","6EdEd","blue-5.19f343d9.jpg","iNEmv","starlight-1.e1160a9f.jpg","gHZKm","starlight-2.e2f047d6.jpg","6zTIB","starlight-3.fa2e190b.jpg","6k6LS","starlight-4.275143dc.jpg","fCzTu","starlight-5.2d017395.jpg","eGW1g","purple-1.2629e5d7.jpg","g7YPL","purple-2.2f506698.jpg","7cxdn","purple-3.c781bf17.jpg","h1OB2","purple-4.1693b1b0.jpg","hzlOx","purple-5.99ab2118.jpg","eDRb9","orange-1.294b87e6.jpg","gejiK","orange-2.ddc94dc0.jpg","5fKrU","orange-3.f03b86f2.jpg","gdLkf","orange-4.1481c4e0.jpg","1Egon","orange-5.1f52adb4.jpg"]'));

var $8598af8aafa580c9$exports = {};
$8598af8aafa580c9$exports = new URL("black-1.b9e2a0c5.jpg", import.meta.url).toString();


var $660b5f3d217bb626$exports = {};
$660b5f3d217bb626$exports = new URL("black-2.a498d6b2.jpg", import.meta.url).toString();


var $079de37914593577$exports = {};
$079de37914593577$exports = new URL("black-3.59840d4e.jpg", import.meta.url).toString();


var $3cc4c31e3ec171cd$exports = {};
$3cc4c31e3ec171cd$exports = new URL("black-4.a3891a45.jpg", import.meta.url).toString();


var $f730f04bed66c3ae$exports = {};
$f730f04bed66c3ae$exports = new URL("black-5.638afd2c.jpg", import.meta.url).toString();


var $ea9ebd61d7514f69$exports = {};
$ea9ebd61d7514f69$exports = new URL("blue-1.515b7ea5.jpg", import.meta.url).toString();


var $5466c73027ce2223$exports = {};
$5466c73027ce2223$exports = new URL("blue-2.72f5326f.jpg", import.meta.url).toString();


var $aa33797af1e6a7b4$exports = {};
$aa33797af1e6a7b4$exports = new URL("blue-3.8869fda4.jpg", import.meta.url).toString();


var $83b280ffa5842870$exports = {};
$83b280ffa5842870$exports = new URL("blue-4.5e1a0e59.jpg", import.meta.url).toString();


var $76910d85f4151528$exports = {};
$76910d85f4151528$exports = new URL("blue-5.19f343d9.jpg", import.meta.url).toString();


var $623a4bceb6431245$exports = {};
$623a4bceb6431245$exports = new URL("starlight-1.e1160a9f.jpg", import.meta.url).toString();


var $4265c150b92290c2$exports = {};
$4265c150b92290c2$exports = new URL("starlight-2.e2f047d6.jpg", import.meta.url).toString();


var $cbbb5310a2b4b646$exports = {};
$cbbb5310a2b4b646$exports = new URL("starlight-3.fa2e190b.jpg", import.meta.url).toString();


var $3d967149bfbba27b$exports = {};
$3d967149bfbba27b$exports = new URL("starlight-4.275143dc.jpg", import.meta.url).toString();


var $7524e55d9ed9b86f$exports = {};
$7524e55d9ed9b86f$exports = new URL("starlight-5.2d017395.jpg", import.meta.url).toString();


var $f94725dfc6cb7fa3$exports = {};
$f94725dfc6cb7fa3$exports = new URL("purple-1.2629e5d7.jpg", import.meta.url).toString();


var $95ef7774e5189928$exports = {};
$95ef7774e5189928$exports = new URL("purple-2.2f506698.jpg", import.meta.url).toString();


var $3941c9a4e2a6db2f$exports = {};
$3941c9a4e2a6db2f$exports = new URL("purple-3.c781bf17.jpg", import.meta.url).toString();


var $9b0178bc03d8482d$exports = {};
$9b0178bc03d8482d$exports = new URL("purple-4.1693b1b0.jpg", import.meta.url).toString();


var $f26d7287c1965978$exports = {};
$f26d7287c1965978$exports = new URL("purple-5.99ab2118.jpg", import.meta.url).toString();


var $c1a45bcc6e920d0f$exports = {};
$c1a45bcc6e920d0f$exports = new URL("orange-1.294b87e6.jpg", import.meta.url).toString();


var $592494133df60382$exports = {};
$592494133df60382$exports = new URL("orange-2.ddc94dc0.jpg", import.meta.url).toString();


var $ac645fac85ab0b25$exports = {};
$ac645fac85ab0b25$exports = new URL("orange-3.f03b86f2.jpg", import.meta.url).toString();


var $7b4672b0cda04b1d$exports = {};
$7b4672b0cda04b1d$exports = new URL("orange-4.1481c4e0.jpg", import.meta.url).toString();


var $ee8d03184b373bae$exports = {};
$ee8d03184b373bae$exports = new URL("orange-5.1f52adb4.jpg", import.meta.url).toString();


const $a8170775ccfc2c4c$var$colorItems = document.querySelectorAll(".color__item");
const $a8170775ccfc2c4c$var$images = document.querySelectorAll(".swiper-image");
$a8170775ccfc2c4c$var$colorItems.forEach((item)=>{
    item.addEventListener("click", ()=>{
        $a8170775ccfc2c4c$var$colorItems.forEach((i)=>{
            i.classList.remove("active");
        });
        item.classList.add("active");
        const colorId = item.id;
        let newPaths = [];
        switch(colorId){
            case "black":
                newPaths = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($8598af8aafa580c9$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($660b5f3d217bb626$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($079de37914593577$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($3cc4c31e3ec171cd$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($f730f04bed66c3ae$exports)))
                ];
                break;
            case "blue":
                newPaths = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($ea9ebd61d7514f69$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($5466c73027ce2223$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($aa33797af1e6a7b4$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($83b280ffa5842870$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($76910d85f4151528$exports)))
                ];
                break;
            case "starlight":
                newPaths = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($623a4bceb6431245$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($4265c150b92290c2$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($cbbb5310a2b4b646$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($3d967149bfbba27b$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($7524e55d9ed9b86f$exports)))
                ];
                break;
            case "purple":
                newPaths = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($f94725dfc6cb7fa3$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($95ef7774e5189928$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($3941c9a4e2a6db2f$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($9b0178bc03d8482d$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($f26d7287c1965978$exports)))
                ];
                break;
            case "orange":
                newPaths = [
                    (0, (/*@__PURE__*/$parcel$interopDefault($c1a45bcc6e920d0f$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($592494133df60382$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($ac645fac85ab0b25$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($7b4672b0cda04b1d$exports))),
                    (0, (/*@__PURE__*/$parcel$interopDefault($ee8d03184b373bae$exports)))
                ];
                break;
            default:
                break;
        }
        newPaths.forEach((path, index)=>{
            if ($a8170775ccfc2c4c$var$images[index]) $a8170775ccfc2c4c$var$images[index].src = path;
        });
    });
});


//# sourceMappingURL=index.2d61e064.js.map
